export const API_BASE_URL = process.env.REACT_APP_API_URL
export const CUSTOMER_SITE_URL = process.env.REACT_APP_CUSTOMER_URL

const createApi = (module, action, method = "post") => ({
	method,
	url: `api/${module}/${action}`,
})

// Auth
export const ApiLogin = createApi('Auth', 'Login')
export const ApiCheckAuth = createApi('Auth', 'CheckAuth')
export const ApiRegister = createApi('Auth', 'Register')

// Brand
export const ApiGetBrandList = createApi('Brand', 'GetList')
export const ApiGetBrandById = createApi('Brand', 'GetById')
export const ApiCreateBrand = createApi('Brand', 'Create')
export const ApiDeleteBrand = createApi('Brand', 'Delete')

// Product
export const ApiGetProductList = createApi('Product', 'GetList')
export const ApiGetProductById = createApi('Product', 'GetById')
export const ApiCreateProduct = createApi('Product', 'Create')
export const ApiUpdateProduct = createApi('Product', 'Update')
export const ApiDeleteProduct = createApi('Product', 'Delete')

// Category
export const ApiGetCategoryList = createApi('Category', 'GetList')
export const ApiGetCategoryById = createApi('Category', 'GetById')
export const ApiCreateCategory = createApi('Category', 'Create')
export const ApiUpdateCategory = createApi('Category', 'Update')
export const ApiDeleteCategory = createApi('Category', 'Delete')

// Customer
export const ApiGetCustomerList = createApi('Customer', 'GetList')
export const ApiGetCustomerById = createApi('Customer', 'GetById')
export const ApiCreateCustomer = createApi('Customer', 'Create')
export const ApiUpdateCustomer = createApi('Customer', 'Update')
export const ApiDeleteCustomer = createApi('Customer', 'Delete')

// Sales Stock
export const ApiGetSalesStockList = createApi('SalesStock', 'GetList')
export const ApiGetSalesStockById = createApi('SalesStock', 'GetById')
export const ApiCreateSalesStock = createApi('SalesStock', 'Create')
export const ApiUpdateSalesStock = createApi('SalesStock', 'Update')
export const ApiDeleteSalesStock = createApi('SalesStock', 'Delete')

// Rental Stock
export const ApiGetRentalStockList = createApi('RentalStock', 'GetList')
export const ApiGetRentalStockById = createApi('RentalStock', 'GetById')
export const ApiCreateRentalStock = createApi('RentalStock', 'Create')
export const ApiUpdateRentalStock = createApi('RentalStock', 'Update')
export const ApiDeleteRentalStock = createApi('RentalStock', 'Delete')
export const ApiGetRentalStockPrice = createApi('RentalStock', 'GetRentalStockPrice')

// Order Sales Transaction
export const ApiGetOrderSalesStockList = createApi('OrderSales', 'GetStockList')
export const ApiCreateSalesOrder = createApi('OrderSales', 'Create')
export const ApiGetOrderSalesById = createApi('OrderSales', 'GetById')
export const ApiDeleteSalesOrder = createApi('OrderSales', 'Delete')

// Order Rental Transaction
export const ApiGetOrderRentalStockList = createApi('OrderRental', 'GetStockList')
export const ApiCreateOrderRental = createApi('OrderRental', 'Create')
export const ApiGetOrderRentalList = createApi('OrderRental', 'GetList')
export const ApiGetOrderRentalById = createApi('OrderRental', 'GetById')
export const ApiOrderRentalDelivered = createApi('OrderRental', 'Delivered')
export const ApiOrderRentalReturned = createApi('OrderRental', 'RentalReturned')

// Transaction
export const ApiGetOrderList = createApi('OrderSales', 'GetList')

// System
export const ApiGetSystem = createApi('System', 'GetSystem')
export const ApiUpdateSystem = createApi('System', 'Update')

// Dashboard
export const ApiGetDashboardList = createApi('Dashboard', 'GetList')
export const ApiGetDashboardHeader = createApi('Dashboard', 'GetDashboardHeader')
export const ApiGetDashboardSummary = createApi('Dashboard', 'GetDashboardSummary')     // Row 1 - summary cards
export const ApiGetDashboardChart = createApi('Dashboard', 'GetDashboardChart')         // Row 2 - charts
export const ApiGetDashboardDetail = createApi('Dashboard', 'GetDashboardDetail')       // Row 3 - detail tables
export const ApiGetDashboardRekap = createApi('Dashboard', 'GetDashboardRekap')         // Row 4 - recap section
export const ApiGetDashboardKeuangan = createApi('Dashboard', 'GetDashboardKeuangan')   // Row 5 - finance section

// Expense Category
export const ApiGetExpenseCategoryList = createApi('ExpenseCategory', 'GetList')
export const ApiCreateExpenseCategory = createApi('ExpenseCategory', 'Create')
export const ApiDeleteExpenseCategory = createApi('ExpenseCategory', 'Delete')

// Expense
export const ApiGetExpenseList = createApi('Expense', 'GetList')
export const ApiGetExpenseById = createApi('Expense', 'GetById')
export const ApiCreateExpense = createApi('Expense', 'Create')
export const ApiUpdateExpense = createApi('Expense', 'Update')
export const ApiDeleteExpense = createApi('Expense', 'Delete')




// User
export const ApiUpdateUser = createApi('User', 'Update')
export const ApiGetUserList = createApi('User', 'GetList')
export const ApiGetUserById = createApi('User', 'GetById')
export const ApiDeleteUser = createApi('User', 'Delete')
export const ApiCheckIsAdmin = createApi('User', 'CheckIsAdmin')

export const ApiGetCompanyAccessDropdown = createApi('Company', 'Dropdown')


// User Access
export const ApiGetUserAccessList = {
	method: 'post',
	url: 'api/UserAccess/GetUserAccessList'
}
export const ApiGetUserMenuAccess = {
	method: 'post',
	url: 'api/UserAccess/GetUserAccessByUserId'
}
export const ApiCheckUserMenuAccess = {
	method: 'post',
	url: 'api/UserAccess/CheckAccess'
}